$(document).ready(function () {
  $(".sabor-input").click(() => {
    $(".sabor-input").addClass("open");
  });

  $(".announcement-dismiss").click(() => {
    $("#section-announcement").addClass("gone").delay(600).fadeOut();
  });

  $(".menu-caller").click(() => {
    $(".drawer-menu-wrapper").toggleClass("open");
    $("body").toggleClass("no-scroll");
    $(".about-overlay").toggleClass("cart__overlay--hidden");
    $(".drawer-about").removeClass("open");
  });

  $(".about-caller").click(() => {
    $(".drawer-about").toggleClass("open");
    $("body").toggleClass("no-scroll");
    $(".about-overlay").toggleClass("cart__overlay--hidden");
    $(".drawer-menu-wrapper").removeClass("open");
  });

  $(".about-overlay").click(() => {
    $(".about-overlay").toggleClass("cart__overlay--hidden");
    $(".drawer-about").removeClass("open");
    $(".drawer-menu-wrapper").removeClass("open");
    $("body").removeClass("no-scroll");
  });

  $(".color-search_wrapper").click(() => {
    $(".color-search_wrapper").toggleClass("open");
    $(".fabric-wrapper").removeClass("open");
  });

  $(".fabric-wrapper").click(() => {
    $(".fabric-wrapper").toggleClass("open");
    $(".color-search_wrapper").removeClass("open");
  });

  $(".menu-closer").click(() => {
    $(".drawer-menu-wrapper").removeClass("open");
    $("body").removeClass("no-scroll");
    $(".about-overlay").addClass("cart__overlay--hidden");
    $(".drawer-about").removeClass("open");
  });

  $(".measurements-toggler").click(() => {
    $(".measurements-toggler").addClass("active");
    $(".frete-toggler").removeClass("active");
    $(".measurements-info").addClass("open");
  });

  $(".close-measurements-button").click(() => {
    $(".frete-toggler").addClass("active");
    $(".measurements-toggler").removeClass("active");
    $(".measurements-info").removeClass("open");
  })

  $(".frete-toggler").click(() => {
    $(".frete-toggler").addClass("active");
    $(".measurements-toggler").removeClass("active");
    $(".measurements-info").removeClass("open");
  });

  $(".input-email.popup").focus(() => {
    if (window.innerWidth < 900 ) {
      console.log("focus")
      $('.pop-up-container').addClass("focused")
    }
  })
  
  $(".input-email.popup").blur(() => {
    if (window.innerWidth < 900 ) {
      console.log("blur")
      $('.pop-up-container').removeClass("focused")
    }
  })


  $(window).on("scroll", function () {
    if ($(window).scrollTop() > 1920) {
      $(".headernav").addClass("nothing");
    } else {
      //remove the background property so it comes transparent again (defined in your css)
      $(".headernav").removeClass("nothing");
    }
  });

  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);

  window.addEventListener("resize", () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  });

  if (window.navigator.appVersion.includes("Windows")) {
    $("body").append(`
			<style>
		
				*::-webkit-scrollbar {
					width: 10px;
				}

				*::-webkit-scrollbar-track {
					background: transparent;
				}

				*::-webkit-scrollbar-thumb {
					background-color: #adadad ;
					border-radius: 6px;
				}
				
			</style>
		`);
  }

    setTimeout(() => {
    $(".pop-up-container").addClass("visible");
  }, 2000);


  $(".pop-up-container").click((e) => {
    $(".pop-up-container").addClass("open");
  });

  $(".close-popup").click((e) => {
    localStorage.setItem("popup", true);
    $(".pop-up-container").addClass("hidden");
  });

  $(".pop-up-container__close-btn").click((e) => {
    $(".pop-up-container").removeClass("visible");
    $(".pop-up-container").addClass("hidden");
  })

  setTimeout(() => {
    $(".header").append(`
				<div class="ship-notice"><span class="gratis-frete"> Frete Grátis</span> a partir de R$ 150</div>
      `);

    // document.querySelector(".floating-cart").onclick = () => {
    //   $("html").addClass("no-scroll-all");
    //   $("body").addClass("no-scroll-all");
    // };

    $(".header > button").click(() => {
      $(".slidecarthq-overlay").removeClass("open");
      $(".slidecarthq").removeClass("open");
      $("html").removeClass("no-scroll-all");
      $("body").removeClass("no-scroll-all");
    });
  }, 2000);

  $(".accordion-row").click((e) => {
    const parent = $(e.target).parents(".accordion-row");
    $(".accordion-row").not(parent).removeClass("open");
    parent.toggleClass("open");
  });

  $("#recover-button").click((e) => {
    $(".recover-pass").addClass("open");
    $("#login-form").addClass("hidden");
  });

  $(".size-selector").click((e) => {
    $(".size-selector").removeClass("active");
    $(e.currentTarget).addClass("active");
    $(".variant-option").attr("value", e.currentTarget.id);
    $("#size-text").text(e.currentTarget.outerText);
    $(".size-options-mobile").toggleClass("open");
    $(".size-mobile").toggleClass("open");
  });

  $(".buy-button").click(() => {
    $("html").addClass("no-scroll-all");
    $("body").addClass("no-scroll-all");
  });

 
  $(".content-wrapper").click(() => {
    gsap.to(window, {
      duration: 1,
      scrollTo: {
        y: "#shopify-section-entrance",
        autoKill: false
      },
      ease: 'power3.out'
    })
  });
 
  $(".collection-video").click(() => {
    gsap.to(window, {
      duration: 1,
      scrollTo: {
        y: "#shopify-section-entrance",
        autoKill: false
      },
      ease: 'power3.out'
    })
  });
});












  (() => {
    function formatBrazilianZip(value) {
      const digits = (value || "").replace(/\D/g, "").slice(0, 8);
      if (digits.length <= 5) return digits;
      return digits.slice(0, 5) + "-" + digits.slice(5);
    }

   function formatShippingMoney(value) {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: Shopify.currency.active || 'BRL'
  }).format(Number(value || 0));
}

    async function prepareShipping(zip) {
      const response = await fetch(`${window.Shopify.routes.root}cart/prepare_shipping_rates.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          shipping_address: {
            zip: zip,
            country: 'Brazil',
            province: 'SP'
          }
        })
      });

      if (!response.ok) {
        throw new Error('Não foi possível preparar o cálculo do frete.');
      }

      return response.json();
    }

    async function fetchShipping(zip) {
      const params = new URLSearchParams({
        'shipping_address[zip]': zip,
        'shipping_address[country]': 'Brazil',
      
      });

      const response = await fetch(`${window.Shopify.routes.root}cart/async_shipping_rates.json?${params.toString()}`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Não foi possível buscar as opções de frete.');
      }

      return response.json();
    }

    async function getShippingRates(zip) {
      await prepareShipping(zip);

      // algumas lojas precisam de uma pequena espera/polling
      for (let i = 0; i < 8; i++) {
        const data = await fetchShipping(zip);

        if (data.shipping_rates && data.shipping_rates.length) {
          return data.shipping_rates;
        }

        if (data.shipping_rates && data.shipping_rates.length === 0) {
          return [];
        }

        await new Promise(resolve => setTimeout(resolve, 700));
      }

      return [];
    }

  function renderShippingRates(rates) {
  const results = document.getElementById('SideCartShippingResults');
  const feedback = document.getElementById('SideCartShippingFeedback');

  if (!results || !feedback) return;

  if (!rates.length) {
    feedback.textContent = 'Nenhuma opção de frete encontrada para esse CEP.';
    results.innerHTML = '';
    return;
  }

  feedback.textContent = 'Opções de entrega:';

  results.innerHTML = rates.map(rate => {
    const name = rate.name || 'Entrega';
    const price = Number(rate.price || 0);

    return `
      <div class="side-cart__shipping-rate">
        <span>${name}</span>
        <strong>${formatShippingMoney(price)}</strong>
      </div>
    `;
  }).join('');
}

    window.cart = window.cart || {};

    window.cart.calculateShipping = async function () {
      const input = document.getElementById('SideCartShippingZip');
      const feedback = document.getElementById('SideCartShippingFeedback');
      const results = document.getElementById('SideCartShippingResults');

      if (!input || !feedback || !results) return;

      input.value = formatBrazilianZip(input.value);
      const zip = input.value.replace(/\D/g, '');

      if (zip.length !== 8) {
        feedback.textContent = 'Digite um CEP válido com 8 números.';
        results.innerHTML = '';
        return;
      }

      feedback.textContent = 'Calculando frete...';
      results.innerHTML = '';

      try {
        const rates = await getShippingRates(zip);
        renderShippingRates(rates);
      } catch (error) {
        console.error(error);
        feedback.textContent = 'Não foi possível calcular o frete agora.';
        results.innerHTML = '';
      }
    };

    document.addEventListener('input', (event) => {
      if (event.target && event.target.id === 'SideCartShippingZip') {
        event.target.value = formatBrazilianZip(event.target.value);
      }
    });
  })();
